import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "card card-flush mb-0",
  "data-kt-sticky": "false",
  "data-kt-sticky-name": "merchants-summary"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-toolbar" }, [
    /*#__PURE__*/_createElementVNode("h5", { class: "mb-4" }, "Summary Details")
  ])
], -1)
const _hoisted_3 = { class: "card-body pt-0 fs-7" }
const _hoisted_4 = { class: "row mb-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "col-5 fs-7 fw-bold text-gray-400" }, "Status:", -1)
const _hoisted_6 = { class: "col text-start" }
const _hoisted_7 = { class: "badge badge-light text-dark py-1 fw-boldest" }
const _hoisted_8 = { class: "mb-4" }
const _hoisted_9 = { class: "row mb-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "col-5 fs-7 fw-bold text-gray-400" }, "Merchant:", -1)
const _hoisted_11 = { class: "col fw-bold text-start" }
const _hoisted_12 = { class: "row mb-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "col-5 fs-7 fw-bold text-gray-400" }, "MID Number:", -1)
const _hoisted_14 = { class: "col text-start fw-bold" }
const _hoisted_15 = { class: "row mb-4" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "col-5 fs-7 fw-bold text-gray-400" }, "Processor:", -1)
const _hoisted_17 = { class: "col text-start fw-bold" }
const _hoisted_18 = {
  key: 0,
  class: "row mb-4"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "col-5 fs-7 fw-bold text-gray-400" }, "Response Status:", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "col fw-bold text-start" }, "Not Sent", -1)
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = {
  key: 1,
  class: "row mb-4"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "col-5 fs-7 fw-bold text-gray-400" }, "Response:", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "col fw-bold text-start" }, "Sent", -1)
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = { class: "mb-4" }
const _hoisted_27 = { class: "row mb-4" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "col-5 fs-7 fw-bold text-gray-400" }, "Reason Category:", -1)
const _hoisted_29 = { class: "col fw-bold text-start" }
const _hoisted_30 = { class: "row mb-3" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "col-5 fs-7 fw-bold text-gray-400" }, "Reason Condition:", -1)
const _hoisted_32 = { class: "col fw-bold text-start" }
const _hoisted_33 = { class: "badge badge-light text-dark py-1 fw-boldest" }
const _hoisted_34 = { class: "row pt-5" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed mb-7" }, null, -1)
const _hoisted_36 = { class: "mb-0 col" }
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" MID Details ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.incoming.chargeback_status), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.merchant.dba_name), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.merchant.mid_number), 1)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.processor.name), 1)
        ]),
        (_ctx.incoming.sent_date == '0000-00-00 00:00:00')
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_21))
          : (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_25))
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _hoisted_28,
          _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.reason.category), 1)
        ]),
        _createElementVNode("div", _hoisted_30, [
          _hoisted_31,
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.incoming.reason_condition), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_34, [
        _hoisted_35,
        _createElementVNode("div", _hoisted_36, [
          _createVNode(_component_router_link, {
            to: `/merchants/accounts/details/${_ctx.incoming.merchant_id}/overview`,
            class: "btn btn-primary btn-clean btn-sm py-2",
            id: "kt_subscriptions_create_button"
          }, {
            default: _withCtx(() => [
              _hoisted_37
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ])
    ])
  ]))
}